// NEW STYPEPARAMS METHOD
var SCROLL_ANIMATIONS = {
    NO_EFFECT: 'NO_EFFECT',
    FADE_IN: 'FADE_IN',
    GRAYSCALE: 'GRAYSCALE',
    SLIDE_UP: 'SLIDE_UP',
    EXPAND: 'EXPAND',
    SHRINK: 'SHRINK',
    ZOOM_OUT: 'ZOOM_OUT',
    ONE_COLOR: 'ONE_COLOR',
    MAIN_COLOR: 'MAIN_COLOR',
    BLUR: 'BLUR',
};
export default SCROLL_ANIMATIONS;
//# sourceMappingURL=behaviourParams_gallery_scrollAnimation.js.map